import { Router } from '@angular/router';
import { NavItem } from 'src/app/interfaces/nav-item';
import { TabService } from 'src/app/services/tab.service';

/**
 * Abre uma tela do módulo numa ABA do shell, como o menu faz.
 *
 * Duas regras do app que um `router.navigate` cru quebraria:
 *
 *  1. **Aba.** O conteúdo do sistema vive dentro das abas do `system-view-new`.
 *     Navegar sem registrar a aba deixa a tela aberta sem nenhuma aba marcada —
 *     e a pessoa não tem como voltar para o que estava fazendo.
 *  2. **URL limpa.** A navegação é sempre `skipLocationChange: true`: as rotas
 *     internas NUNCA aparecem na barra de endereços. É o padrão do
 *     `NavService.selectItem2`, e o que impede alguém de colar uma rota
 *     interna e cair nela fora do shell.
 *
 * Aba já aberta é reaproveitada, e não duplicada.
 */
export function abrirAbaDeChamados(
    tabService: TabService,
    router: Router,
    url: string,
    idMenu: string,
    iconName: string
): void {

    const existente = tabService.tabs.findIndex(aba => aba.url === url);

    if (existente >= 0) {
        tabService.activeTabIndex.next(existente);

    } else {

        // O `addTab` procura primeiro em `tabOptions`, montado a partir do menu
        // do usuário: quando ele tem o item, a aba nasce com o nome e o ícone
        // do menu. Sem o item, cai no fallback com o que passamos aqui.
        tabService.addTab({ id: idMenu, route: url, iconName: iconName } as NavItem);

        // Índice da aba recém-criada. O `NavService` usa `length + 1` aqui, o
        // que aponta para fora da lista; como este caminho não passa por ele,
        // usamos o índice real.
        tabService.activeTabIndex.next(tabService.tabs.length - 1);
    }

    // O atraso é o mesmo do NavService: a aba precisa existir na lista antes de
    // a rota trocar, senão o `onTabChange` corrige o índice de volta.
    setTimeout(() => router.navigate([url], { skipLocationChange: true }), 100);
}
